<ng-container *ngIf="loaded">
  <ng-template [ngIf]="imported" [ngIfElse]="notImported">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      class="imported"
    >
      <g clip-path="url(#clip0_833_32836)">
        <rect width="20" height="20" rx="10" fill="#2DBBFC" />
        <path
          d="M8.176 12.7269L6.20699 10.7578C5.98479 10.5356 5.62453 10.5356 5.40233 10.7578C5.18013 10.98 5.18013 11.3403 5.40233 11.5625L8.1602 14.3204C8.16893 14.3291 8.18308 14.3291 8.1918 14.3204L14.5977 7.91451C14.8199 7.69231 14.8199 7.33205 14.5977 7.10985C14.3755 6.88765 14.0152 6.88765 13.793 7.10985L8.176 12.7269Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_833_32836">
          <rect width="20" height="20" rx="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </ng-template>

  <ng-template #notImported>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M16.125 8.36658C15.5583 5.49159 13.0333 3.33325 10 3.33325C7.59167 3.33325 5.5 4.69992 4.45833 6.69992C1.95 6.96658 0 9.09158 0 11.6666C0 14.4249 2.24167 16.6666 5 16.6666H15.8333C18.1333 16.6666 20 14.7999 20 12.4999C20 10.2999 18.2917 8.51658 16.125 8.36658ZM11.6667 10.8333V14.1666H8.33333V10.8333H5.83333L10 6.66658L14.1667 10.8333H11.6667Z"
        fill="black"
        fill-opacity="0.6"
      />
    </svg>
  </ng-template>
</ng-container>
